/**
 * 导入初始化
 */
import { setupWebViewJavascriptBridge } from './core';

/**
 * 导入工具类
 */
import { isAndroid, isHarmonyOs } from './utils';

/**
 * 初始化
 */
setupWebViewJavascriptBridge((bridge: any) => {
  if (isAndroid() || isHarmonyOs()) {
    bridge.init((_message: any, responseCallback: any) => {
      const data = { 'Javascript Responds': '测试中文!' };
      if (responseCallback) {
        responseCallback(data);
      }
    });
  }
});

export * from './bridge';
export * from './utils';
